import { DateTime } from 'aos-helpers/src/helpers/Time'
import { translateCode } from 'aos-helpers/src/helpers/translations/Translations'
import { TFunction } from 'i18next'

import { InspectionGroup, translateInspectionGroup } from './InspectionGroup'

export interface InspectionType {
    id: number
    name: string
    code?: string
    inspectionGroup: InspectionGroup
    period?: number
    taskEndTime?: DateTime
}

export const translateInspectionTypeName =
    (t: TFunction) => (v: Pick<InspectionType, 'code' | 'name'>) =>
        translateCode(t)('inspection-item', v.code, v.name)

export const translateInspectionType = (t: TFunction) => (v: InspectionType) =>
    `${translateInspectionGroup(t)(v.inspectionGroup)} / ${translateInspectionTypeName(t)(v)}`
